import { connect } from "react-redux";
import {
    allocateTrunkNumbersByTemplate,
    allocateTrunkNumbersByNumberList,

    setAllocatedNumbersByTemplate,
    setAllocatedNumbersByNumberList,
    setTrunkNumberTransaction,
    setLoadingAllocatedNumbers,
    setUploadingLoading,

    downloadNumbers,

    getNumberTrunksList,
    getTrunkNumbers,
    setTrunkList,

    setTrunkNumbers
} from "actions/client/numbers";
import { showReasonHandler } from "actions/reason_handler";

import Numbers from "./Numbers";


const mapState = ({ client_numbers, auth, auth_dialer, references }) => ({
    trunksList: client_numbers.numberTrunks.filter((trunk) => !trunk.is_reseller),
    numbersList: client_numbers.allocatedNumbers,
    accountList: auth_dialer.accountJoinList,

    trunkLoading: client_numbers.numberTrunkLoading,
    numbersLoading: client_numbers.allocatedNumbersLoading,
    allocationLoading: client_numbers.loadingAllocatedNumbers,

    totalNumbersCount: client_numbers.totalNumbersCount,
    outgoingIpForAiTrunk: references?.global_setting?.outgoing_ip_for_ai_trunk,

    page: client_numbers.page,
    count: client_numbers.count,
    perPage: client_numbers.per_page,
    uploadLoading: client_numbers.uploadTrunkLoading,

    trunkNumberTransaction: client_numbers.trunk_number_transaction,

    accountData: auth.authInfo,
    accountDialerData: auth_dialer.dialerInfo,
    service: auth_dialer.serviceDialer,

    permittedMethods: auth.permittedMethods,
});

export default connect(
    mapState,
    {
        getTrunkList: getNumberTrunksList,
        setTrunkList,
        getTrunkNumbersList: getTrunkNumbers,
        downloadNumbers,
        allocateTrunkNumbersByNumberList,
        allocateTrunkNumbersByTemplate,
        setAllocatedNumbersByNumberList,
        setAllocatedNumbersByTemplate,
        setNumberList: setTrunkNumbers,
        setAllocatedNumbersLoading: setLoadingAllocatedNumbers,
        setTrunkNumberTransaction,
        setUploadingLoading,
        showReasonHandler
    }
)(Numbers);